export default "__VITE_ASSET__c00c56fa__"